import { makeStyles } from "@mui/styles";
import React from 'react';

export const useStyleTablePaginatorActions = makeStyles((theme) => ({
        root: {
            flexShrink: 0,
            color: theme.palette.text.secondary,
            marginLeft: theme.spacing.unit * 2.5,
        }
    }));